import React, { useEffect } from "react";
import { FaAngleLeft } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import {
  clearResult,
  getAResult,
  getResultHistoryData,
  getResulthistoryError,
  getResultHistoryStatus,
} from "../../../redux/slice/historySlice";

import AlertBox from "../../common/AlertBox";
import Loading from "../../common/Loading";
import ResultFragment from "../../home/examPage/ResultFragment";

const AdminSingleResult = () => {
  const submitId = useParams().id;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const status = useSelector(getResultHistoryStatus);
  const error = useSelector(getResulthistoryError);
  const data = useSelector(getResultHistoryData);

  useEffect(() => {
    dispatch(getAResult(submitId));
    return () => {
      dispatch(clearResult());
    };
  }, [dispatch, submitId]);

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <section className="flex flex-col gap-12 w-full">
      {status === "loading" ? <Loading /> : null}
      {status === "failed" ? <AlertBox type="failed" message={error} /> : null}
      <div className="flex w-full justify-between items-center">
        <h1 className="text-[24px] font-semibold">Result</h1>
      </div>
      <div className="bg-primary flex flex-col gap-4 w-full sm:p-7 p-2 rounded-[4px] border border-adminMainBorder">
        <button
          type="button"
          onClick={handleBack}
          className="w-14 flex flex-row gap-2 items-center"
        >
          <FaAngleLeft />
          <span>Back</span>
        </button>
        {data && <ResultFragment examData={data} />}
      </div>
    </section>
  );
};

export default AdminSingleResult;
